<template>
  <club-form class="card card-body rounded-top" :edit="true" @updated="updated" />
</template>

<script>
import { notificationsMixin } from '@/mixins/notifications';
import ClubForm from '@/components/forms/ClubForm';

// @vuese
// Edycja klubu
// @group Club
export default {
  components: { ClubForm },
  methods: {
    updated() {
      this.$router.push({ name: 'club', params: this.$route.params.id });
    }
  }
};
</script>
